module.exports = __webpack_public_path__ + "img/page-26.340be33c.jpg";